import React from 'react';
import TrendsButton, { TrendsButtonsProps } from './TrendsButton';
import ClearAllButton, { ClearAllButtonsProps } from './ClearAllButton';

interface TrendsAndClearButtonsProps {
  ClearAllButtonProps: ClearAllButtonsProps;
  TrendsButtonProps: TrendsButtonsProps;
}

const TrendsAndClearButtons = ({
  ClearAllButtonProps, TrendsButtonProps,
}: TrendsAndClearButtonsProps) => (
  <>
    <TrendsButton {...TrendsButtonProps} />
    <ClearAllButton {...ClearAllButtonProps} />
  </>
);

export default TrendsAndClearButtons;
